import { GoogleLogin } from '@react-oauth/google'
import { useNavigate } from '@tanstack/react-router'
import { useAuth, apiErrorMessage } from '~/lib/auth'

export function GoogleAuthButton({
  onError,
  onCredential,
  text = 'continue_with',
}: {
  onError: (message: string) => void
  onCredential?: (credential: string) => Promise<void> | void
  text?: 'continue_with' | 'signin_with' | 'signup_with'
}) {
  const { googleAuth } = useAuth()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <span className="h-px flex-1 bg-[var(--line)]" />
        <span className="font-mono text-[10px] tracking-[0.16em] uppercase text-ink-mute">
          or
        </span>
        <span className="h-px flex-1 bg-[var(--line)]" />
      </div>
      <div className="flex justify-center">
        <GoogleLogin
          theme="outline"
          text={text}
          shape="rectangular"
          width="320"
          onSuccess={async (resp) => {
            if (!resp.credential) {
              onError('Google sign-in failed')
              return
            }
            try {
              if (onCredential) {
                await onCredential(resp.credential)
              } else {
                await googleAuth(resp.credential)
                navigate({ to: '/dpp' })
              }
            } catch (err) {
              onError(apiErrorMessage(err, 'Google sign-in failed'))
            }
          }}
          onError={() => onError('Google sign-in failed')}
        />
      </div>
    </div>
  )
}
